import { useRouter } from 'next/router';
import { CareerItem } from 'presentations/api/schema/contents';
import { ServicePortalContext } from 'presentations/reducers/ServicePortal';
import { careerPath, webPath } from 'presentations/routes/path';
import { useContext } from 'react';

export interface Props {
  item: CareerItem;
}

export const useCareerPage = (props: Props) => {
  const { state: serviceState } = useContext(ServicePortalContext);
  const viewer = serviceState.viewer;

  const router = useRouter();
  const shareUrl = webPath(careerPath(props.item.slug), router.locale);

  return {
    state: {
      viewer,
      shareUrl,
    },
    actions: {},
  };
};
